import React from 'react';

interface ToggleButtonProps {
  value: boolean;
  onChange: (value: boolean) => void;
  label?: string;
  required?: boolean;
  yesLabel?: string;
  noLabel?: string;
  icon?: string;
}

export const ToggleButton: React.FC<ToggleButtonProps> = ({
  value,
  onChange,
  label,
  required = false,
  yesLabel = 'Yes',
  noLabel = 'No',
  icon,
}) => {
  return (
    <div className="space-y-2">
      {label && (
        <label className="flex items-center gap-2 text-base font-semibold text-gray-700">
          {icon && (
            <img src={icon} alt="" className="w-5 h-5 object-contain" />
          )}
          <span>
            {label}
            {required && <span className="text-red-500 ml-1">*</span>}
          </span>
        </label>
      )}
      <div className="inline-flex rounded-lg border border-gray-300 overflow-hidden">
        <button
          type="button"
          onClick={() => onChange(true)}
          className={`px-6 py-2 text-sm font-medium transition-colors ${
            value
              ? 'bg-primary-600 text-white'
              : 'bg-white text-gray-700 hover:bg-gray-50'
          }`}
        >
          {yesLabel}
        </button>
        <button
          type="button"
          onClick={() => onChange(false)}
          className={`px-6 py-2 text-sm font-medium transition-colors border-l border-gray-300 ${
            !value
              ? 'bg-primary-600 text-white'
              : 'bg-white text-gray-700 hover:bg-gray-50'
          }`}
        >
          {noLabel}
        </button>
      </div>
    </div>
  );
};
